export default __webpack_public_path__ + "static/media/export-pdf.329ff740.svg";